export default __webpack_public_path__ + "static/media/front-mobile.9eba2c08.png";